var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text button-width",attrs:{"depressed":"","rounded":"","color":_vm.color ? _vm.color : 'primary'},on:{"click":_vm.buttonClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }